(function () {
  'use strict';

  angular
    .module('itecAdministracio.entitats.main.llicencies')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('entitats.main.submain.llicencies', {
        url: '/llicencies',
        views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: function(entitatsHeaderSubmenuLinksValue){
                return entitatsHeaderSubmenuLinksValue;
              }
            }
          },
          'content@entitats.main.submain': {
            templateUrl: 'entitats/main/llicencies/llicencies.tpl.html',
            controller: 'EntitatsMainLlicenciesCtrl',
            controllerAs: 'ctrl'
          }
        },
        breadcrumb: 'DEFAULT_PRODUCTES'
      });
  }
}());
